import React, { createContext, useContext, useMemo } from "react";
import { isStorefrontFoundationEnabled } from "./featureFlags";
import { resolveStorefrontPreset } from "./presentation/presets";

const disabledValue = { enabled: false, preset: null };
const StorefrontFoundationContext = createContext(disabledValue);

export const useStorefrontFoundation = () =>
  useContext(StorefrontFoundationContext);

const StorefrontFoundationBoundary = ({ settings, children }) => {
  const enabled = isStorefrontFoundationEnabled(settings);
  const value = useMemo(
    () => ({
      enabled,
      preset: enabled ? resolveStorefrontPreset(settings) : null,
    }),
    [enabled, settings],
  );

  if (!enabled) return children;
  return (
    <StorefrontFoundationContext.Provider value={value}>
      {children}
    </StorefrontFoundationContext.Provider>
  );
};

export default StorefrontFoundationBoundary;
